import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { OnDisplayService } from '../ondisplay/onDisplay.service';

@Injectable({ providedIn: 'root' })
export class CallbackService {
	constructor(private http: HttpClient, private utils: UtilsService, private onDisplaySrv: OnDisplayService) {}

	getCallbacks(userId: any, campaignId: any): Observable<any> {
		const formData: any = new FormData();
		formData.append('user_id', userId);
		formData.append('campaign_id', campaignId);

		const url: string = `${environment.api}caller/campaigns/get_callbacks`;
		return this.http.post(url, formData);
	}

	updateCallback(callback: any): Observable<any> {
		const formData: any = new FormData();
		formData.append('callback_id', callback.callback_id);
		formData.append('callback_date', callback.callback_date);

		const url: string = `${environment.api}caller/campaigns/update_callback`;
		return this.http.post(url, formData);
	}

	deleteCallback(callback_id: any): Observable<any> {
		const formData: any = new FormData();
		formData.append('callback_id', callback_id);

		const url: string = `${environment.api}caller/campaigns/delete_callback`;
		return this.http.post(url, formData);
	}

	getReschedules(campaignId: any): Observable<any> {
		const formData: any = new FormData();
		formData.append('campaign_id', campaignId);

		const url: string = `${environment.api}caller/campaigns/get_reschedules`;
		return this.http.post(url, formData);
	}

	updateReschedule(reschedule: any): Observable<any> {
		const formData: any = new FormData();
		formData.append('reschedule_id', reschedule.id);
		formData.append('app_date', reschedule.date_generated);

		const url: string = `${environment.api}caller/campaigns/update_reschedule`;
		return this.http.post(url, formData);
	}

	getPendingReschedules(campaignId: any): Observable<any> {
		const url: string = `${environment.api}campaigns/${campaignId}/reschedules`;
		return this.http.get(url);
	}

	rescheduleQA(reschedule: any, newDate: string, user: any, sendNotification: boolean = false): Observable<any> {
		const formData: any = new FormData();
		const newDateTime = dayjs(newDate);


		formData.append('lead_id', reschedule.prospect_id ?? reschedule.lead_id ?? reschedule.id);
		formData.append('alias', reschedule.campaign_alias ?? reschedule.alias ?? '');
		formData.append('new_date', newDateTime.format('YYYY-MM-DD HH:mm:ss'));
		formData.append('newHour', newDateTime.format('hh'));
		formData.append('newMin', newDateTime.format('mm'));
		formData.append('ampm', newDateTime.format('A'));
		formData.append('reason', '');
		formData.append('status', 'Pending');
		formData.append('resolved_by', user?.IdUser);
		formData.append('newTime', newDateTime.format('HH:mm:ss'));
		formData.append('calendar_id', reschedule.calendar_id ?? '');
		formData.append('user_login', user?.Login);
		formData.append('user_id', user?.IdUser);
		formData.append('send_notification', sendNotification ? '1' : '0');

		const url: string = `${environment.api}lead/reschedule_qa`;
		return this.http.post(url, formData);
	}
}
